export enum ProjectStatus {
    PROCESS = 'PROCESS',
    FINISHED = 'FINISHED',
    CANCELED = 'CANCELED',
    SUSPENDED = 'SUSPENDED',
  }

export enum OrderType {
    SPRINT = 'SPRINT',
    COLUMNBOARD = 'COLUMNBOARD',
  }